import sha256 from 'crypto-js/sha256';

export const hashEmail = email => {
  if (email == null) return null;

  const normalized = String(email).trim().toLowerCase();

  if (!normalized) return null;

  return sha256(normalized).toString();
};
